import InvestmentsTable from '@/components/investments/InvestmentsTable';

const InvestmentsPage = () => {
  return (
    <div className="px-4 py-6">
      <InvestmentsTable />
    </div>
  );
};

export default InvestmentsPage;
